export const CustomerSegmentTypes = [
  'MANUFACTURER',
  'IMPORTER',
  'WHOLESALER',
  'RETAILER',
  'END_CONSUMER',
];
